
import { USER_ROLES } from '@/utils/dictionaries/user'
import URLS from '@/constants/url'

const userPrefix = 'user_'
const userCarPrefix = 'last_car_'

export function getUser (row) {
  const user = {}
  const createKey = (oldKey = '') => {
    return oldKey ? oldKey.replace(userPrefix, '') : ''
  }

  for (const [key, value] of Object.entries(row)) {
    if (key.includes(userPrefix)) {
      user[createKey(key)] = value
    }
  }

  return user
}

export function createUserObject (obj) {
  const user = { ...obj }

  for (const [key, value] of Object.entries(obj)) {
    user[userPrefix + key] = value
  }

  return user
}

export function getRawUserId (u) {
  return u.id || u.user_id
}

export function getRawUserCarId (u) {
  return u.last_car_id
}

export function createUserCarObject (car) {
  const result = {}
  const toSnakeCase = (s) => {
    s.replace(/\.?([A-Z])/g, function (x, y) { return '_' + y.toLowerCase() }).replace(/^_/, '')
  }

  for (const [key, value] of Object.entries(car)) {
    result[userCarPrefix + toSnakeCase(key)] = value
  }

  return result
}

export function getCar (car) {
  const result = { ...car }
  const createKey = (oldKey = '') => {
    return oldKey ? oldKey.replace(userPrefix, '') : ''
  }

  for (const [key, value] of Object.entries(result)) {
    if (key.includes(userPrefix)) {
      result[createKey(key)] = value
    }
  }

  return result
}

export function getUserRole(user) {
  switch (user.role) {
    case USER_ROLES.RoleSuperAdmin: return 'Administrator'
    case USER_ROLES.RoleAdmin: return 'Manager'
    default: return 'User'
  }
}

export function getUserLink(username) {
  return username ? `${URLS.app}/user/${username}` : ''
}